/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Import_Hls_HelpInputs */



/**
* | output |
* | --- |
* | "Enter the URL of your HLS manifest file" |
*
* @param {Media_Import_Hls_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const media_import_hls_help = /** @type {((inputs?: Media_Import_Hls_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Import_Hls_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Saisissez l'URL de votre fichier manifeste HLS")
	if (locale === "de") return /** @type {LocalizedString} */ ("Geben Sie die URL Ihrer HLS-Manifestdatei ein.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Inserisci l'URL del tuo file manifest HLS")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Введите URL-адрес вашего файла манифеста HLS.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Ingrese la URL de su archivo de manifiesto HLS")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("输入您的 HLS 清单文件的 URL")
	if (locale === "ja") return /** @type {LocalizedString} */ ("HLSマニフェストファイルのURLを入力してください")
	if (locale === "hi") return /** @type {LocalizedString} */ ("अपनी HLS मैनिफेस्ट फ़ाइल का URL दर्ज करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Insira a URL do seu arquivo de manifesto HLS.")
	return /** @type {LocalizedString} */ ("Enter the URL of your HLS manifest file")
});